import React from 'react';
import Button from '../../components/button/Button';
import Popup from './Popup';
import { usePopupContext } from '../contexts/PopupContext';
import CheckboxButton from '../buttons/CheckboxButton';
import { BUTTONS_TEXT } from '../../constants/popups';
import { useAppContext } from '../contexts/AppContext';
import { useAppConfigContext } from '../contexts/AppConfigContext';
import { linkOnClickHandler } from '../navigation/navigation';

const CHECKBOX_TEXT = 'Do not show this message again.';

const POPUP_TEXT =
    'The order of the FLO Progress Monitoring forms has been updated. The new passage order is available in the Progress Monitoring books sent to your district (as of September 2023). These new books are also available to download free from the Amplify PD Library';

const mesageUpdateLink = url => (
    <span>
        {' '}
        <a href={url} rel="noopener noreferrer" target="_blank">
            here <i className='dashboard-navigation-link-icon' />
        </a>
    </span>
);

const DigitalFormsPopup = () => {
    const {
        userPopupsSettings: { isDigitalPopupEnabled },
        params: {
            assessmentLink,
            measureName,
            onCancelHandler,
            skillName,
            grade,
            studentId,
            initialFormUidsByGrade,
        },
        actions: { hideDigitalPopup, enableVisiblityDigitalPopup },
    } = usePopupContext();

    const { checkAndGetSessionStatus } = useAppContext();
    const { floPMPopupLink } = useAppConfigContext();

    const onChange = () => {
        enableVisiblityDigitalPopup(!isDigitalPopupEnabled);
    };

    const onCancel = () => {
        hideDigitalPopup();
        enableVisiblityDigitalPopup(true);
        if (onCancelHandler) {
            onCancelHandler({
                skillName,
                measureName,
                grade,
                studentId,
                initialFormUidsByGrade,
            });
        }
    };

    const startAssessment = linkOnClickHandler(assessmentLink, checkAndGetSessionStatus);

    return (
        <Popup
            header={<p>{measureName} PM Passages</p>}
            message={
                <p>
                    {POPUP_TEXT}
                    {mesageUpdateLink(floPMPopupLink)}
                </p>
            }
            buttons={[
                <div key="buttons" className='dashboard-popup-buttons-container'>
                    <Button onClick={onCancel}>{BUTTONS_TEXT.CANCEL}</Button>
                    <Button onClick={startAssessment}>{BUTTONS_TEXT.CONTINUE}</Button>
                </div>,
                <div key="chb-button-1" className='dashboard-do-not-show-chb'>
                    <CheckboxButton
                        key="chb-button-2"
                        name={CHECKBOX_TEXT}
                        id="checkbox-input"
                        value="marked"
                        isChecked={!isDigitalPopupEnabled}
                        onChange={onChange}
                    />
                </div>,
            ]}
            cssClass="flo-digital-form-popup"
        />
    );
};

export default DigitalFormsPopup;
